import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class httpClientInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const url = req.url || '';
    const isAbsolute = /^https?:\/\//i.test(url);
    const isAsset = url.startsWith('assets/');

    // Si ya es absoluta o es asset, no modificar
    if (isAbsolute || isAsset) {
      return next.handle(req);
    }

    // Construir URL completa
    const apiUrl = environment.apiUrl || '';
    const relative = url.replace(/^\//, '');
    const prefixedUrl = `${apiUrl}/${relative}`;

    const cloned = req.clone({ url: prefixedUrl });
    return next.handle(cloned);
  }
}
